import { render, staticRenderFns } from "./PoartaA.vue?vue&type=template&id=7f0a5784&scoped=true"
import script from "./PoartaA.vue?vue&type=script&lang=js"
export * from "./PoartaA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a5784",
  null
  
)

export default component.exports